/* eslint-disable */
import JSEncrypt from 'jsencrypt'
import CryptoJS from 'crypto-js'

const pubKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIApzmogRLa0fp4+Y+6nhgVy66\
01d7ZlBzeicEXs06xRmfyf5wcW2E58yVmxyhyoHJgpRsOFPN6DbhFbM05VOzWZOt\
VUNPc3VYixmtAtOUKDqlVKf9Xq97jenlYZznEKzuezkVv7QlfmaACqgzm2dblRyn\
XHh32lKzZoxrHUCSdQIDAQAB'

let previousStamp = null
let cur_rsa_key = null

//RSA加密AES原始Key
const encryptRSA = (originKey) => {
  let en = new JSEncrypt()
  en.setPublicKey(pubKey)
  return en.encrypt(originKey)
}

//AES Key
export const getAESKeys = () => {
  const stamp = new Date().getTime()
  if (!previousStamp || !cur_rsa_key || stamp - previousStamp > 10 * 1000) {
    //超时换key
    previousStamp = stamp
    let originKey = CryptoJS.MD5(
      `${previousStamp}_${Math.random()
        .toString(36)
        .substr(2)}`
    )
      .toString()
      .substr(0, 16)
    const rsaKey = encryptRSA(originKey)
    cur_rsa_key = {
      origin: originKey,
      sec: rsaKey
    }
  }
  return cur_rsa_key
}

export const encryptAES = (key, originData) => {
  const iv = CryptoJS.enc.Latin1.parse(key)
  const encKey = CryptoJS.enc.Latin1.parse(key)
  const encData = CryptoJS.AES.encrypt(originData, encKey, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.ZeroPadding,
    iv
  })
  const encStr = encData.toString()
  return encStr
}
